/**
 * notify uses qtip to show a dialog in a notification style
 */

(function($) {
	$.notify = function(message, title, stick, classes, dismiss){
		var target = $('.qtip.jgrowl:visible:last');

		if($('#growl-notification-box').length == 0)
			$('#top').after('<div id="growl-notification-box"></div>');

		if(target.length < 1)
			target = $('#growl-notification-box');

		if(typeof classes == 'undefined')
			classes = '';

		if(typeof title == 'undefined')
			title = false;

		if(stick !== true)
			stick = false;

		$(document.body).qtip({
			content: {
				text: message,
				title: {
					text: title,
					button: false,
				},
			},
			position: {
				my: 'top middle',
				at: (target.hasClass('jgrowl') ? 'bottom' : 'top') + ' middle',
				target: target,
				adjust: {
					y: 5
				},
				viewport: $(window)
			},
			show: {
				event: false,
				ready: true,
				effect: function(api) {
					$(this).stop(0,1).fadeIn(400);
				},
				persistent: stick,
			},
			hide: {
				event: false,
				ready: false,
				effect: function(api){
					var $tooltip = $(api.elements.tooltip)
					$tooltip.stop(0,1).fadeOut(400).queue(function() {
						// Destroy this tooltip after fading out
						api.destroy();
						// Update positions
						$.updateGrowls();
					});
				}
			},
			style: {
				tip: false,
				classes: 'jgrowl ui-tooltip-rounded ui-tooltip-shadow ' + classes
			},
			events: {
				render: function(event, api){
					growlTimer.call(api.elements.tooltip, event);
				},
				hide: function(){
					if(typeof dismiss == 'function') {
						dismiss();
					}
				}
			}
		}).removeData('qtip');
	};

	$.updateGrowls = function(){
		// Loop through each active qtip
		var each = $('.qtip.jgrowl:not(:animated)');
		each.each(function(i){
			var api = $(this).data('qtip');

			// Set the target option directly to prevent reposition() from being called twice.
			api.options.position.target = !i ? $('#growl-notification-box') : each.eq(i - 1);
			api.set('position.at', (!i ? 'top' : 'bottom') + ' middle');
		});
	};

	function growlTimer(event){
		var api = $(this).data('qtip'),
		lifespan = 5000; // 5 second lifespan
		// If persistent is set to true, don't do anything.
		if(api.get('show.persistent') === true) { return; }

		// Otherwise, start/clear the timer depending on event type
		clearTimeout(api.timer);
		if(event.type !== 'mouseover') {
			api.timer = setTimeout(function (){
				api.hide();
			}, lifespan);
		}
	}

	// Utilise delegate so we don't have to rebind for every qTip!
	$(document).delegate('.qtip.jgrowl', 'mouseover mouseout', growlTimer);
	$(document).delegate('.qtip.jgrowl', 'click', function(){
		$(this).data('qtip').hide();
	});

})(jQuery);
